import { CustomerType, OrderType } from '@repo/common';
import {
    Card,
    CardContent,
    Tabs,
    TabsList,
    TabsTrigger,
    cn,
} from '@repo/shadcn';
import { Loader2Icon } from 'lucide-react';
import { useState } from 'react';

import { logError } from '@/utils';

import { useCartContext } from './cart.context';

export const OrderTypeSelector = () => {
    const { orderType, activeCart, changeOrderType } = useCartContext();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleRetailButtonClick = async () => {
        try {
            setIsLoading(true);
            await changeOrderType(OrderType.RETAIL);
        } catch (error) {
            logError('OrderTypeSelector:handleRetailButtonClick', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleWholesaleButtonClick = async () => {
        try {
            setIsLoading(true);
            await changeOrderType(OrderType.WHOLESALE);
        } catch (error) {
            logError('OrderTypeSelector:handleWholesaleButtonClick', error);
        } finally {
            setIsLoading(false);
        }
    };

    const canChangeOrderType = activeCart?.data?.items?.length === 0;

    return (
        <Card>
            <CardContent className="px-0 py-0">
                <Tabs className="" value={orderType} defaultValue={orderType}>
                    <TabsList className="grid w-full grid-cols-2">
                        <TabsTrigger
                            disabled={!canChangeOrderType}
                            value={CustomerType.RETAIL}
                            className={cn(
                                'data-[state=active]:bg-primary data-[state=active]:text-white',
                                !canChangeOrderType && 'cursor-not-allowed',
                            )}
                            onClick={handleRetailButtonClick}
                        >
                            {isLoading ? (
                                <Loader2Icon
                                    className={'size-4 animate-spin'}
                                />
                            ) : (
                                'Retail'
                            )}
                        </TabsTrigger>
                        <TabsTrigger
                            value={CustomerType.WHOLESALE}
                            disabled={!canChangeOrderType}
                            onClick={handleWholesaleButtonClick}
                            className={cn(
                                'data-[state=active]:bg-primary data-[state=active]:text-white',
                                !canChangeOrderType && 'cursor-not-allowed',
                            )}
                        >
                            {isLoading ? (
                                <Loader2Icon
                                    className={'size-4 animate-spin'}
                                />
                            ) : (
                                'Wholesale'
                            )}
                        </TabsTrigger>
                    </TabsList>
                </Tabs>
            </CardContent>
        </Card>
    );
};

OrderTypeSelector.displayName = 'OrderTypeSelector';
